import { computed } from '@vue/composition-api';
import { useCommonColumns } from '@/views/Brand/Applications/Offer/Details/composables/use-common-columns';
import { useAcceptanceColumns } from '@/views/Brand/Applications/Offer/Details/composables/use-acceptance-columns';
export const useReservationColumns = (ctx, offer, shownYear) => {
    const { commonColumns } = useCommonColumns(ctx, { offer, shownYear });
    const { acceptanceColumns } = useAcceptanceColumns(ctx, {
        offer,
        decisionSelectId: 'reservation-decision-select',
        isReadOnlyAcceptance: true,
    });
    const columns = computed(() => {
        return [
            ...commonColumns.value,
            {
                field: 'isRejected',
                headerName: ctx.root.$t('offer-costs.clMediaDecisionLabel').toString(),
                maxWidth: 200,
                width: 110,
                flex: 1,
                hide: !offer.isApprovalRequired,
                cellRenderer: 'ReservationDecisionCell',
                cellRendererParams: (params) => {
                    return {
                        isRejected: params?.value,
                    };
                },
                valueGetter: (params) => {
                    return params?.data?.isRejected ?? '';
                },
                pinned: 'right',
                suppressMovable: true,
            },
            ...(offer.isApprovalRequired ? acceptanceColumns : []),
        ];
    });
    return { columns };
};
